import React, { useEffect, useState } from "react";
import "../../styles/pelvicSenseEmailCapture.css";
import { useSelector, useDispatch } from "react-redux";
import checkIcon from "../../img/Vector.png";
import checkPurple from "../../img/check_circle_black_24dp.png";
import { Link } from "react-router-dom";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import { addEmailRecipient } from "../../features/emailCollection/emailCollectionSlice";
import { NewFooter } from "../../components/newFooter";

export const PelvicSenseEmailCapture = () => {
  const { message, isError } = useSelector((state) => state.emailCollection);
  console.log(message);
  const [formValue, setFormValue] = useState({
    email: "",
    type: "PelvicSense",
  });
  const [check, setCheck] = useState(false);
  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };
  // const [basicModal, setBasicModal] = useState(false);

  // const toggleShow = () => setBasicModal(!basicModal);

  const [centredModal, setCentredModal] = useState(false);

  const toggleShow = () => setCentredModal(!centredModal);

  // const navigate = useNavigate()
  const dispatch = useDispatch();

  useEffect(() => {
    if (formValue.email.length > 0 && formValue.email.includes("@")) {
      if (
        formValue.email.includes(".com") ||
        formValue.email.includes(".net") ||
        formValue.email.includes(".org") ||
        formValue.email.includes(".gov") ||
        formValue.email.includes(".uk") ||
        formValue.email.includes(".us") ||
        formValue.email.includes(".io") ||
        formValue.email.includes(".co")
      ) {
        setCheck(true);
      } else {
        setCheck(false);
      }
    } else {
      setCheck(false);
    }
  }, [formValue]);
  return (
    <>
      <div className="pelvicSenseEmailCapture pt-5">
        <div className=" d-flex justify-content-center align-items-center">
          <div>
            <div className="text-center pt-3">
              <h3 className="text-al fs-32-24 mb-5">
                We’re so glad you’re here.
              </h3>
              <div className="text-start padding-space-emailProgram">
                <p className="text-dm m-0">
                  1. Enter your email address below.
                </p>
                <p className="text-dm m-0">
                  2. Get a 10% off discount code sent to your inbox.
                </p>
                <p className="text-dm m-0">
                  3. Sign Up for your PelvicSense plan.
                </p>
              </div>
              <div className="mt-5">
                <div className="d-grid padding-space-emailProgram">
                  <label className="text-start">Enter your email</label>
                  <span>
                    <input
                      className="input-pelvic-sense-email-capture"
                      onChange={onChange}
                      value={formValue.email}
                      name="email"
                    />
                    {/* {check && <img src={checkIcon} className='ms-2'/> } */}
                  </span>
                  <button
                    className={
                      check === false
                        ? "button-pelvic-care-email-capture-disable mt-4"
                        : "button-pelvic-care-email-capture-enable mt-4"
                    }
                    disabled={!check}
                    onClick={() => {
                      toggleShow();
                      dispatch(addEmailRecipient(formValue));
                    }}
                  >
                    SEND ME A DISCOUNT
                  </button>
                </div>
              </div>
            </div>
          </div>

          <MDBModal show={centredModal} setShow={setCentredModal} tabIndex="-1">
            <MDBModalDialog centered>
              <MDBModalContent className="bg-modal-program">
                {/* <MDBModalHeader>
              <MDBModalTitle></MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleShow}></MDBBtn>
            </MDBModalHeader> */}
                <MDBModalBody>
                  {isError ? (
                    <div className="text-center">
                      <h4 className="text-al mt-2">{message}</h4>
                      <Link to="/">
                        <button className="button-newindividualpage">
                          BACK TO HOME
                        </button>
                      </Link>
                    </div>
                  ) : (
                    <div className="text-center pt-3 p-4">
                      <img
                        src={checkPurple}
                        className="logo-modal-pelvic-program"
                      />
                      <h1 className="text-al title-modal-program mt-2">
                        Thank you for joining us!
                      </h1>
                      <p className="text-dm p-tex-modal">
                        Check your inbox for your 10% off discount code to
                        PelvicSense.
                      </p>
                      <Link to="/">
                        <button className="button-newindividualpage mt-4">
                          BACK TO HOME
                        </button>
                      </Link>
                    </div>
                  )}
                </MDBModalBody>

                {/* <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleShow}>
                Close
              </MDBBtn>
              <MDBBtn>Save changes</MDBBtn>
            </MDBModalFooter> */}
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        </div>
        <div className="m-0 pb-3">
          <p className="text-center px-5 mt-5 fs-12 text-dm">
            I consent to Elana Inc. processing data I provide, so that Elana
            Inc. can provide services to me. By clicking <br className="mobile-view-hidden" />
            "Send Me a Discount" you acknowledge that you have read, understood,
            and accepted the Terms and <br className="mobile-view-hidden" /> Conditions and Privacy Policy. I
            also agree to receive updates and special offers from Elana Inc.
          </p>
        </div>
      </div>
      <NewFooter />
    </>
  );
};
